<template>
  <b-modal
    id="confirm-modal"
    ref="confirmModal"
    :title="confirmTitle"
    :class="{
      'no-title': !confirmTitle,
    }"
    @hidden="resolveConfirm"
    v-model="toggleConfirm"
    hide-footer>
    <div v-html="confirmMsg"></div>

    <div class="mt-3 d-flex align-items-center justify-content-end">
      <div
        v-if="suppressID"
        class="mr-auto">
        <b-form-checkbox
          id="suppress"
          name="suppress"
          ref="suppress"
          v-model="suppress">
          Don't show this message again
        </b-form-checkbox>
      </div>

      <b-button
        type="button"
        variant="success"
        @click="handleSuppress(); confirmed = true; toggleConfirm = false;">
        Yes
        <font-awesome-icon icon="check-circle"></font-awesome-icon>
      </b-button>

      <b-button
        type="button"
        class="ml-3"
        variant="danger"
        @click="handleSuppress(); toggleConfirm = false;">
        No
        <font-awesome-icon icon="times-circle"></font-awesome-icon>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      confirmTitle: '',
      confirmMsg: '',
      toggleConfirm: false,
      suppressID: null,
      suppress: false,
      confirmed: false,
    };
  },
  methods: {
    handleSuppress() {
      if (this.suppress) {
        localStorage.setItem(this.suppressID, JSON.stringify(true));
      }
    },
    resolveConfirm() {
      // emit event
      this.$root.$emit('hide-confirm', this.confirmed);

      // clear data
      this.toggleConfirm = false;
      this.confirmTitle = '';
      this.confirmMsg = '';
      this.suppressID = null;
      this.suppress = false;
      this.confirmed = false;
    },
  },
  created() {
    this.$root.$on('show-confirm', (data) => {
      this.toggleConfirm = true;
      this.confirmTitle = data.title;
      this.confirmMsg = data.msg;
      this.suppressID = data.suppressID;
    });
  },
};
</script>

<style lang="scss">
.no-title {
  .modal {
    .modal-header {
      padding-top: .25rem;
      padding-bottom: .35rem;
      padding-right: .4rem;
    }
  }
}
</style>
